import { watchEffect} from "vue"

export const usePageTitle = () => {

    const changePageTitle       = (title) => {
        document.title = `MEC Profil | ${title}`
    }

    const watchPageTitleChange       = (titleRef) => {
        watchEffect(() => {
            changePageTitle(titleRef.value)
        });
    }

    return {
        changePageTitle,
        watchPageTitleChange
    }
};